import React, { Component } from 'react';
import { getAppCfg } from '../../utils/common';
import { Grid } from '@material-ui/core';

function TermAndConditionsPage(props) {
    const resul = getAppCfg()
    const about_details = resul&&resul.about_details?resul.about_details: null
    var    content = about_details && about_details.terms_conditions && about_details.terms_conditions.content ? about_details.terms_conditions.content : ""
    return (
            <Grid item>    
                <div dangerouslySetInnerHTML={{__html: content}}/>
            </Grid>

    );
}

export default TermAndConditionsPage;